"use strict";

/**
 * @ngdoc function
 * @name diceApp.component:personModal
 * @personEdit Edits a person
 */
angular.module("diceApp").component("personModal", {
  bindings: {
    modal: "<",
    person: "<",
    isEditable: "<",
    onSave: "&",
    onDelete: "&"
  },
  templateUrl: "es6/members/person.modal.html",
  controllerAs: "personController",
  controller: function (Person) {
    const personController = this;

    personController.close = function () {
      personController.modal.close();
    };

    personController.save = function () {
      Person.store(personController.person).$promise.then((result) => {
        personController.onSave({ person: result });
        personController.close();
      });
    };

    personController.remove = function () {
      Person.remove(personController.person.id).$promise.then(function () {
        personController.onDelete({ person: personController.person });
        personController.close();
      });
    };
  }
});
